export default [
	{
		path: '/admin/academic/trainer-profiles',
		name: 'trainer-profile',
		meta: { requiresAuth: true },
		component: () => import('@/pages/academic/trainer-profile/index.vue')
	},
	{
		path: '/admin/academic/trainer-profiles/create',
		name: 'trainer-profile-create',
		meta: { requiresAuth: true },
		component: () => import('@/pages/academic/trainer-profile/create.vue')
	},
	{
		path: '/admin/academic/trainer-profiles/:id/edit',
		name: 'trainer-profile-edit',
		meta: { requiresAuth: true },
		component: () => import('@/pages/academic/trainer-profile/edit.vue')
	}
]
